import { Box, Button, Container, Divider, Grid, Skeleton, TextField, Typography } from '@mui/material'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { IMaskInput } from 'react-imask';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../reduxState/store';
import { profile } from '../../reduxState/customerProfile/profileUpdate';
import MyorderTab from './myorderTab';
import { Gallery_BASE_URL } from '../../config';
import profileImage from '../../assets/images/image.svg'
import { singleFileUpload } from '../../reduxState/fileupload/singleFileUpload';
import _ from 'lodash'
import AppSnackbar from '../commonToast/customizeAlert';
import GoToTop from '../commonToast/ontopScroll';
import { useLocation } from 'react-router-dom';
import { clearState } from '../../reduxState/addressSlice/addressAddSlice';
import { clearUpdateState } from '../../reduxState/addressSlice/addressUpdateSlice';

const OrderPage: React.FC = () => {
  const token = localStorage.getItem('AUTH_TOKEN')
  const loading = useSelector((state: RootState) => state.profileList.loading);
  const profileList = useSelector((state: RootState) => state.profileList.data);
  const profileUpdate = useSelector((state: RootState) => state.profileUpdate);
  const addressAdd = useSelector((state: RootState) => state.addressAdd);
  const addressUpdate = useSelector((state: RootState) => state.addressUpdate);
  const dispatch = useDispatch<AppDispatch>();
  const [state, setState] = React.useState<any>(0)
  const customerUploadState = useSelector((state: RootState) => state.singleUpload.data)
  const [image, setImage] = React.useState(customerUploadState);
  const [isSnackbarOpen, setIsSnackbarOpen] = React.useState(false);
  const [isErrorSnackbarOpen, setIsErrorSnackbarOpen] = React.useState(false);
  const location = useLocation();
  const defaultAddress = useSelector((state: RootState) => state.addressDefaultUpdate)
  const orderReview = useSelector((state: RootState) => state.orderReview)
  const orderDelete = useSelector((state: RootState) => state.orderDelete)

  // alert messages
  React.useEffect(() => {
    if (profileUpdate.code === 200 || addressAdd.code === 200 || addressUpdate.code === 200 || orderReview.code === 200 || orderDelete.code === 200) {
      setIsSnackbarOpen(true);
    } else if (defaultAddress.code === 400 || profileUpdate.code === 400 || orderReview.code === 400 || orderDelete.code === 400) {
      setIsErrorSnackbarOpen(true);
    }
  }, [defaultAddress.code, profileUpdate.code, addressAdd.code, addressUpdate.code, orderReview.code, orderDelete.code]);

  React.useEffect(() => {
    setImage(customerUploadState)
  }, [customerUploadState])

  const validationSchema = Yup.object({
    firstName: Yup.string().required('First name is required').notOneOf(['Guest'], 'Guest is not allowed'),
    lastName: Yup.string().required('Last name is required').matches(/^[a-zA-Z]+$/, 'Please enter a valid name'),
    email: Yup.string().email().required(),
    phoneNumber: Yup.string().required('Phone Number is required'),
    profile: Yup.string(),
  })

  const { handleSubmit, control, reset } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      profile: ''
    }
  });

  const onSubmit = (event: any) => {
    const payload: any = {
      firstName: event.firstName.trim(),
      lastName: event.lastName.trim(),
      email: event.email.trim(),
      mobileNo: event.phoneNumber.trim(),
      profile: '',
    }
    payload.profile = image?.filePath
    dispatch(profile(payload))
    setState(0)
  }

  React.useEffect(() => {
    reset({
      firstName: profileList?.firstName ? profileList?.firstName : '',
      lastName: profileList?.lastName ? profileList?.lastName : '',
      email: profileList?.email ? profileList?.email : '',
      phoneNumber: profileList?.mobileNo,
      profile: profileList?.profile ? profileList.profile : image?.filePath,
    })
    setImage(profileList?.profile,)
  }, [profileList, token, state])

  const handleChangeEdit = () => {
    setState(1)
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files: any = e.target.files?.[0]
    const formData = new FormData()
    formData.append('file', files)
    dispatch(singleFileUpload(formData))
  }

  const handleProfileImageClick = () => {
    const inputElement = document.getElementById('profile-image-upload') as HTMLInputElement | null;
    if (inputElement) {
      inputElement.click();
    }
  };

  const handleSnackbarClose = () => {
    setIsSnackbarOpen(false);
    setIsErrorSnackbarOpen(false);
    dispatch(clearState())
    dispatch(clearUpdateState())
  };

  return (
    <Box className='bg-head' pt={2} pb={4}>
      <Container fixed>
        <Box className='order-box'>
          {/* Profile details */}
          {state === 1 || !token ?
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container p={3} columns={11} justifyContent={'space-between'}>
                <Grid item xs={11} sm={5} lg={3}>
                  <Controller
                    name="firstName"
                    control={control}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                      <TextField
                        margin="normal"
                        required
                        placeholder={profileList?.firstName === 'Guest' ? "Type here" : ''}
                        fullWidth
                        id="firstName"
                        label="First Name"
                        name="firstName"
                        variant="standard"
                        className='order-customer-input'
                        value={value || ''}
                        onChange={onChange}
                        error={!!error}
                        helperText={error ? error.message : null}
                        InputProps={{
                          onKeyPress: (event) => {
                            const regex = /^[a-zA-Z\s]+$/;
                            if (!regex.test(event.key) || value.length >= 20) {
                              event.preventDefault();
                            }
                          },
                          autoComplete: 'off',
                        }}
                      />
                    )}
                  />
                  <Controller
                    name="phoneNumber"
                    control={control}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                      <TextField
                        margin="normal"
                        disabled
                        fullWidth
                        id="phoneNumber"
                        label="Phone Number"
                        name="phoneNumber"
                        value={value || ''}
                        onChange={onChange}
                        variant="standard"
                        className='order-customer-input'
                        minRows={10}
                        error={!!error}
                        helperText={error ? error.message : null}
                        InputProps={{
                          autoComplete: 'off',
                          inputComponent: IMaskInput as any,
                          inputProps: {
                            mask: '0000000000',
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={11} sm={5} lg={3}>
                  <Controller
                    name="lastName"
                    control={control}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                      <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="lastName"
                        label="Last Name"
                        name="lastName"
                        variant="standard"
                        className='order-customer-input'
                        value={value || ''}
                        onChange={onChange}
                        error={!!error}
                        helperText={error ? error.message : null}
                        InputProps={{
                          onKeyPress: (event) => {
                            const regex = /^[a-zA-Z\s]+$/;
                            if (!regex.test(event.key) || value.length >= 20) {
                              event.preventDefault();
                            }
                          },
                          autoComplete: 'off',
                        }}
                      />
                    )}
                  />
                  <Controller
                    name="email"
                    control={control}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                      <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email"
                        name="email"
                        variant="standard"
                        className='order-customer-input'
                        value={value || ''}
                        onChange={onChange}
                        error={!!error}
                        helperText={error ? error.message : null}
                        InputProps={{
                          autoComplete: 'off',
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={11} sm={12} lg={3} textAlign={'center'}>
                  <Grid container columns={12} spacing={2} px={3}>
                    <Grid item xs={12} lg={12} display='flex' justifyContent='center' >
                      {!_.isEmpty(image) ? (
                        <img
                          src={`${Gallery_BASE_URL}${image.filePath || image}`}
                          width={'155px'}
                          height={'155px'}
                          alt="Profile picture"
                          style={{ borderRadius: '50%', objectFit: 'cover' }}
                          loading='lazy'
                        />
                      ) : (
                        <img
                          src={profileImage}
                          width={'155px'}
                          height={'155px'}
                          alt="Profile picture"
                          style={{ borderRadius: '50%', objectFit: 'cover' }}
                          loading='lazy'
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} lg={12} display='flex' justifyContent='center'>
                      <Button variant="text" onClick={handleProfileImageClick} className='change-profile roboto-med'>
                        Change Profile Image
                      </Button>
                      <input
                        accept="image/*"
                        id="profile-image-upload"
                        type="file"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={11} textAlign={'center'}>
                  <Button variant='contained' sx={{ width: '10%', mt: 1 }} className='verify-button roboto-med' onClick={handleSubmit(onSubmit)}>
                    {profileList?.id ? "Update" : "Save"}
                  </Button>
                </Grid>
              </Grid>
            </form> :
            <Box p={3} px={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                {loading ?
                  <Skeleton width={'10%'}>
                    <Typography className='order-profile-head reem-kulfi'>.</Typography>
                  </Skeleton> :
                  <>
                    {profileList?.firstName === null ?
                      <Typography className='order-profile-head reem-kulfi'>My Name</Typography> :
                      <Typography className='order-profile-head reem-kulfi'>{`${profileList?.firstName} ${profileList?.lastName}`}</Typography>}
                  </>}
                {loading ?
                  <Skeleton width={'10%'}>
                    <Typography className='product-list-name roboto-med'>.</Typography>
                  </Skeleton> :
                  <Button variant='text' onClick={handleChangeEdit} className='profile-edit-button reem-kulfi'>Edit</Button>}
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }} mt={1}>
                {loading ?
                  <Skeleton width={'10%'}>
                    <Typography className='order-profile-details roboto-med' sx={{ paddingRight: '6px' }}>.</Typography>
                  </Skeleton> :
                  <Typography className='order-profile-details roboto-med' sx={{ paddingRight: '6px' }}>{profileList?.mobileNo}</Typography>}
                {loading ?
                  <Skeleton width={'10%'}>
                    <Typography className='order-profile-details roboto-med' sx={{ paddingLeft: '6px', borderLeft: '1px solid #999999' }}>.</Typography>
                  </Skeleton> :
                  <Typography className='order-profile-details roboto-med' sx={{ paddingLeft: '6px', borderLeft: '1px solid #999999' }}>{profileList?.email}</Typography>}
              </Box>
            </Box>}
          {/* My order tabs */}
          <MyorderTab number={location.state} />
        </Box>
        {isSnackbarOpen && (
          <AppSnackbar
            showAlert={isSnackbarOpen}
            message={profileUpdate.message || addressAdd.message || addressUpdate.message || orderReview.message || orderDelete.message}
            type="success"
            onClose={handleSnackbarClose}
          />
        )}
        {isErrorSnackbarOpen && (
          <AppSnackbar
            showAlert={isErrorSnackbarOpen}
            message={profileUpdate.message || addressAdd.message || addressUpdate.message || orderReview.message || orderDelete.message}
            type="error"
            onClose={handleSnackbarClose}
          />
        )}
        <GoToTop />
      </Container>
    </Box>
  )
}

export default OrderPage